<template>
  <th class="text-center">
    <v-dialog v-model="dialog" max-width="400px" content-class="rounded-xl">
      <template v-slot:activator="{ on }">
        <v-btn fab x-small text v-on="on">
          <v-icon small>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Фильтр {{ num }}</span>
          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs centered icons-and-text>
          <v-tab>
            Точное значение
            <v-icon left>mdi-bullseye-arrow</v-icon>
          </v-tab>
          <v-tab>
            Список
            <v-icon left> mdi-format-list-bulleted</v-icon>
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-select
                  label="Выберите счёт"
                  :items="variants"
                  item-value="name"
                  item-text="name"
                  clearable
                  hide-details
                  :menu-props="{
                    bottom: true,
                    offsetY: true,
                  }"
                  class="caption font-weight-black"
                  @change="changed"
                  v-model="selected"
                >
                </v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn class="success" right @click="successClicked">
                  <v-icon>mdi-check</v-icon>
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card id="range-coef">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-select
                      label="Выбрано"
                      required
                      clearable
                      multiple
                      :items="variants_list"
                      :menu-props="{
                        bottom: true,
                        offsetY: true,
                        maxWidth: 320,
                      }"
                      item-text="name"
                      v-model="selectedMultiple"
                    ></v-select>
                  </v-row>
                  <v-row>
                    <v-checkbox
                      label="Исключить эти значения"
                      v-model="checkbox"
                    ></v-checkbox>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  class="success"
                  right
                  @click="successClickedMultiple"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="success" @click="successClicked">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
        <!-- <v-btn class="error" @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    entity: {
      type: String,
      default: "",
    },
    num: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: "",
      selectedMultiple: "",
      dialog: false,
      checkbox: false,
      variants: [
        { id: 0, name: "" },
        { id: 1, name: "5:0" },
        { id: 2, name: "5:1" },
        { id: 3, name: "5:2" },
        { id: 4, name: "5:3" },
        { id: 5, name: "5:4" },

        { id: 6, name: "0:5" },
        { id: 7, name: "1:5" },
        { id: 8, name: "2:5" },
        { id: 9, name: "3:5" },
        { id: 10, name: "4:5" },
      ],
      variants_list: [
        { id: 1, name: "5:0" },
        { id: 2, name: "5:1" },
        { id: 3, name: "5:2" },
        { id: 4, name: "5:3" },
        { id: 5, name: "5:4" },

        { id: 6, name: "0:5" },
        { id: 7, name: "1:5" },
        { id: 8, name: "2:5" },
        { id: 9, name: "3:5" },
        { id: 10, name: "4:5" },
      ],
    };
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey"]),
    changed: function () {
      // console.log("Changed:" + this.selected, "Side:" + this.num);

      this.selectedMultiple = [];
      var key = "score__first_score";
      var lookup = this.checkbox ? "__not_in" : "__in";
      var key_to_delete = this.entity + "first_score" + lookup;
      // console.log("DELETING IN SUCCESS: " + key_to_delete);
      this.cleanKey(key_to_delete);

      key_to_delete = this.entity + "second_score" + lookup;
      // console.log("DELETING IN SUCCESS: " + key_to_delete);
      this.cleanKey(key_to_delete);

      key_to_delete = this.entity + "first_score";
      // console.log("DELETING IN SUCCESS: " + key_to_delete);
      this.cleanKey(key_to_delete);

      key_to_delete = this.entity + "second_score";
      // console.log("DELETING IN SUCCESS: " + key_to_delete);
      this.cleanKey(key_to_delete);

      if (this.selected == null) {
        this.updateEvent();
        return;
      }
      var value = this.selected[0];
      // console.log("SeTTING in Changed: " + value);
      this.updateForm(key, value);

      key = "score__second_score";
      value = this.selected[2];
      // console.log("SeTTING in Changed 2: " + value);
      this.updateForm(key, value);
      this.updateEvent();
    },
    successClicked: function () {
      this.dialog = false;
      this.checkbox = false;
      this.selectedMultiple = [];
      var lookup = this.checkbox ? "__not_in" : "__in";
      // :TODO: FIX
      var key_to_delete = this.entity + "first_score" + lookup;
      // console.log("DELETING IN SUCCESS: " + key_to_delete);
      this.cleanKey(key_to_delete);

      key_to_delete = this.entity + "second_score" + lookup;
      // console.log("DELETING IN SUCCESS: " + key_to_delete);
      this.cleanKey(key_to_delete);

      let key = this.entity + this.num;
      let value = this.selected;
      // console.log("Selected: " + value);

      this.updateForm(key, value);
      this.updateEvent();
    },
    successClickedMultiple: function () {
      // First clean other filters to avoid conflicts
      this.dialog = false;
      this.selected = "";
      var lookup = this.checkbox ? "__not_in" : "__in";
      this.cleanKey("score__first_score");
      this.cleanKey("score__second_score");

      // Then updating form
      var first_selected = [];
      var second_selected = [];

      // console.log("SELECTED: " + this.selectedMultiple);
      // console.log("typeof: " + this.selectedMultiple);
      for (const val of this.selectedMultiple) {
        // console.log("VALUE: " + val);
        first_selected.push(val[0]);
        second_selected.push(val[2]);
      }
      // console.log("First selected" + first_selected);
      // console.log("Second selected" + second_selected);
      var key = this.entity + "first_score" + lookup;
      var value = first_selected;
      // console.log("Selected: " + value);
      this.updateForm(key, value);
      key = this.entity + "second_score" + lookup;
      value = second_selected;
      // console.log("Selected: " + value);
      // console.log("SeTTING in MULTIPLE: " + value);
      this.updateForm(key, value);

      this.updateEvent();
    },

    cleanKey: function (key_to_delete) {
      this.deleteFilterKey({ key_to_delete });
    },

    updateForm: function (key, value) {
      this.setFilterKey({ key, value });
    },
    updateEvent: function () {
      this.$emit("filter_update");
    },
  },
};
</script>

<style scoped></style>
